"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateVersion = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _GeneralButton = require("../../atoms/GeneralButton");

var _styles = require("./styles");

var _closeVersionSelector = _interopRequireDefault(require("../../../assets/images/versionSelector/closeVersionSelector.svg"));

var _react = require("react");

var _RenderChilds = require("./RenderChilds");

var _axios = _interopRequireDefault(require("axios"));

var _jsxRuntime = require("react/jsx-runtime");

var CreateVersion = function CreateVersion(_ref) {
  var articleId = _ref.articleId,
      version = _ref.version,
      setShowCreateVersion = _ref.setShowCreateVersion,
      versionsList = _ref.versionsList,
      realoadVersion = _ref.realoadVersion,
      jwt = _ref.jwt;

  var _useState = (0, _react.useState)("version-options"),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = (0, _react.useState)({
    datasheet: version,
    description: version,
    image: version
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectedVersions = _useState4[0],
      setSelectedVersions = _useState4[1];

  var createVersion = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(isEmpty) {
      var data;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = {
                articleId: articleId,
                isEmpty: isEmpty
              };
              if (!isEmpty) data["version"] = selectedVersions;
              _context.next = 5;
              return _axios.default.post(process.env.REACT_APP_VERSIONS_ENDPOINT, data, {
                headers: {
                  Authorization: jwt
                }
              });

            case 5:
              setShowCreateVersion(false);
              realoadVersion && realoadVersion();
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function createVersion(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onChange = function onChange(e) {
    setSelectedVersions((0, _objectSpread3.default)((0, _objectSpread3.default)({}, selectedVersions), {}, (0, _defineProperty2.default)({}, e.target.name, parseInt(e.target.value))));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: "create-version",
      className: "modal-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "button-container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
          image: _closeVersionSelector.default,
          buttonType: "circular-button",
          id: "close-modal-button",
          onClick: function onClick() {
            return setShowCreateVersion(false);
          }
        })
      }), (0, _RenderChilds.Children)(step, setStep, versionsList, selectedVersions, onChange, createVersion)]
    })
  });
};

exports.CreateVersion = CreateVersion;